import { ESTADOS_CATEGORIAS } from '../../features/estados/useEstados.js';

const COLORES = {
  activo: 'bg-blue-100 text-blue-800',
  neutro: 'bg-gray-100 text-gray-600',
  conversion: 'bg-green-100 text-green-800',
  perdida: 'bg-red-100 text-red-800',
  descalificado: 'bg-gray-100 text-gray-400 line-through',
};

function categoriaDeEstado(estado) {
  return Object.entries(ESTADOS_CATEGORIAS).find(([, estados]) => estados.includes(estado))?.[0] ?? 'neutro';
}

export function EstadoBadge({ estado }) {
  const categoria = categoriaDeEstado(estado);
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium font-['Inter'] ${COLORES[categoria]}`}>
      {estado}
    </span>
  );
}
